module.exports = __webpack_public_path__ + "img/VetoSansCond-CondLight.8dfe73ff.svg";